import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../auth.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
@Component({
  selector: 'app-forget-password-details',
  templateUrl: './forget-password-details.component.html',
  styleUrls: ['./forget-password-details.component.css']
})
export class ForgetPasswordDetailsComponent {
  
  constructor(
    private fb: FormBuilder,
    private authServ: AuthService,
    private tstr: ToastrService,
    private r: Router
  ) {
    
  }
  signInForm = this.fb.group({
    email: [],
    password: ['', Validators.required],
    password_confirmation: ['', Validators.required],
    token:['', Validators.required]
  });
  hide = true;
  hide1 = true;
  eye() {
    this.hide = !this.hide;
  }
  signIn() {
    this.signInForm.value['email'] = this.authServ.emailRes
    this.authServ.passwordReset(this.signInForm.value).subscribe((result) => {
      this.tstr.success(result.message)
      this.r.navigate(['signin'])
    })
}
}